<template>
    
        <div>
            <div v-for="(value, key) in InputObject" :key="key" class="mb-2">
                <strong :style="{ 'margin-left': (depth * 10) + 'px', 'color' : '#1976D2'}">{{ formatKey(key) }} : </strong>
                <span v-if="value === null" :style="{ 'margin-left': (depth * 10) + 'px' }">null</span>
                <ObjectLoop v-else-if="typeof value === 'object' && !Array.isArray(value)" :InputObject="value" :depth="depth + 1" />
                <span v-else :style="{ 'margin-left': (depth * 10) + 'px' }">{{ value }}</span>
            </div>
        </div>
  
</template>

<script>
export default {
    name: "ObjectLoop",
    props: {
        InputObject: {
            type: Object,
            required: true
        },
        depth: {
            type: Number,
            default: 0
        }
    },
    components: {
        // This component is recursive, so it needs to reference itself
        // It's common practice to define a local reference for recursive components
        ObjectLoop: () => import('./ObjectLoop.vue')
    },
    methods: {
        formatKey(key) {
            // Convert snake_case to Title Case for better readability
            return key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
        }
    }
};
</script>

